/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Number_Input_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Enter number of segments" |
*
* @param {Segment_Event_Group_Number_Input_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_number_input_aria_label = /** @type {((inputs?: Segment_Event_Group_Number_Input_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Number_Input_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrer le nombre de segments")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die Anzahl der Segmente ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il numero di segmenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите количество сегментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el número de segmentos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入段数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメント数を入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंडों की संख्या दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o número de segmentos")
	return /** @type {LocalizedString} */ ("Enter number of segments")
});